module.exports = __webpack_public_path__ + "img/pagbank-logo.77d4e916.png";